module.exports = __webpack_public_path__ + "static/media/C0.e8c0964e.svg";